var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":true,"title":"“Calling out around the world”","image":{ source: '/assets/images/photos/news', formats: ['avif', 'webp', 'jpg'], fallback: 'jpg' }}}),_c('ContentRow',{attrs:{"noPadding":true}},[_c('Blogs',{attrs:{"filter":_vm.filter}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }